const zh = {
  common: {
    platformTitle: 'FutureFlu',
    platformSubtitle: '季节性流感疫苗株推荐平台',
    copyright: '保留所有权利。',
    developedBy: '由 The WAP Lab 开发',
    switchLang: '切换语言',
    home: '首页',
    help: '帮助',
    recommendations: '推荐',
    yearLabel: '年流感季使用的疫苗',
    headerSubtitle: '推荐在 {{year}} 年流感季使用的疫苗',
    goToCurrentSeason: '查看当前流感季流行动态',
    countryNote: '历列国家为南，北半球中可用序列数据排名前五的国家。',
    subtype: '亚型',
    region: '地区',
    year: '年份',
    hemisphere: '北半球',
    hemisphereSouthern: '南半球',
    hemisphereLabel: '按半球选择',
    countryLabel: '按国家选择',
    subtypeH3N2: '甲型流感 (H3N2)',
    subtypeH1N1: '甲型流感 (H1N1)pdm09',
    subtypeB: '乙型流感 (Victoria)',
    countryCN: '中国',
    countryUS: '美国',
    countryJP: '日本',
    countryUK: '英国',
    countryDE: '德国',
    loading: '数据加载中...',
    loadError: '数据加载失败',
    yes: '是',
    no: '否',
    high: '高',
    medium: '中',
    low: '低',
    northAmerica: '北美',
    europe: '欧洲',
    asia: '亚洲',
    southAmerica: '南美',
    africa: '非洲',
    oceania: '大洋洲',
    tooltip: '请选择历史年份查看对应数据',
    back: '返回',
    refresh: '刷新数据',
    lastUpdated: '最后更新时间',
    noData: '暂无数据',
    emptyMsg: '没有关键突变数据',
    noDataDesc: '当前没有可用的流感季数据，请稍后再试',
    reload: '重新加载',
    loadDataFailed: '加载数据失败',
    retryLoad: '重新加载',
    refreshData: '刷新数据',
    futureflurecommended: 'FutureFlu推荐',
    whorecommended: 'WHO推荐',
    phylogeneticTree: '进化树',
    en: 'EN',
    zh: '中',
  },
  help: {
    title: '帮助',
    dataSource: {
      title: '数据来源',
      content: '本网站中分析所用的序列数据来自于全球流感数据共享倡议 (GISAID) 平台：http://platform.gisaid.org/。我们感谢所有医护人员和科学家的贡献，以及 GISAID 团队、提交实验室和来源实验室的支持。'
    },
    contact: {
      title: '联系我们',
      organization: '中国医学科学院系统医学研究院/苏州系统医学研究所',
      email: '电子邮箱',
      address: '联系地址',
      addressDetail: '江苏省苏州工业园区崇文路100号'
    },
    reserved: {
      placeholder: '此区域预留待用'
    }
  },
  home: {
    mainTitle: 'FutureFlu：季节性流感疫苗株智能推荐平台',
    card1Title: '当前流感季监测动态',
    card1Subtitle: '实时监控全球流感病毒分支进化关系和流行情况',
    card1Alt: '当前流感季动态图',
    card2Title: '下一流感季可能的优势分支排序',
    card2Alt: '下一流感季优势分支图',
    card3Title: 'FutureFlu为下一流感季推荐的疫苗株',
    card3Alt: '疫苗推荐图',
    northernHemisphere: '北半球',
    southernHemisphere: '南半球',
    yearText: '年',
    seasonText: '流感季',
    potentialDominantBranches: '流感季可能的优势分支及风险突变',
    vaccineRecommendation: '流感季的疫苗',
    computedByFutureFlu: '该结果由FutureFlu计算所得',
    loadSubtypesFailed: '加载亚型数据失败',
    loadRegionsFailed: '加载地区数据失败',
    loadYearsFailed: '加载年份失败',
    helpTitle: '关于',
    northernHemisphereInfo: '北半球：流感季节为T年9月至T+1年2月，在T年2月做出预测。',
    southernHemisphereInfo: '南半球：流感季节为T年2月至T年9月，在T-1年9月做出预测。',
  },
  currentSeason: {
    title: '当前流感季的流行病学动态',
    desc: '实时监控全球流感病毒流行情况，为预测模型提供最新的基础数据',
    mainTitle: '当前流感季分析',
    phylogeneticTree: '进化树',
    circulationDynamics: '流行动态',
    keyMutations: '关键突变',
    keyMutationsTooltip: '数据由 Nextstrain 项目提供',
    keyMetrics: {
      updatedTo: '数据更新至',
      mainSubtype: '全球主要亚型',
      dominantStrain: '当前优势毒株',
      fastestGrowing: '7日增长最快毒株',
    },
    regionData: {
      northAmerica: '北美',
      europe: '欧洲',
      asia: '亚洲',
      southAmerica: '南美',
      africa: '非洲',
      oceania: '大洋洲',
      high: '高',
      medium: '中',
      low: '低',
    },
    legend: '图例 Legend',
    percentage: '百分比',
    vaccineNode: '疫苗株节点',
    nodeDesc1: '图中节点圆圈的面积反映对应clade所代表的序列丰度',
    nodeDesc2: '疫苗株节点高亮显示，鼠标悬停可查看详细信息',
    cladeRelation: '当前分支进化关系',
    cladeTree: '进化树可视化',
    cladeMutations: '分支关键突变',
    cladeMutationHeatmap: '分支突变热图',
    branch: '分支',
    mutation: '突变',
    hasMutation: '有突变',
    axisDesc: '横坐标标示各突变位点，纵坐标为分支，红色表示该分支有该突变，鼠标悬停可查看详细信息',
    cladeTrends: '当前分支流行动态',
    weeklyPercent: '每周分支百分比，颜色与左侧进化树一致，悬停可查看详细数据',
    loadSequenceCountsFailed: '加载序列数量数据失败',
    loadVaccineStrainsFailed: '加载疫苗株信息失败',
    loadTreeDataFailed: '加载进化树数据失败',
    simpleTreeLoadFailed: '简单进化树加载失败',
    detailedTreeLoadFailed: '详细进化树加载失败',
    getSimpleTreeVaccineInfoFailed: '获取简单进化树疫苗株信息失败',
    getDetailedTreeVaccineInfoFailed: '获取详细进化树疫苗株信息失败',
    cannotGetAnyTreeData: '无法获取任何进化树数据',
    cannotParseTreeStructure: '无法解析树结构',
    parseTreeStringFailed: '解析树字符串失败',
    loadMutationDataFailed: '加载突变数据失败',
    getCirculationDynamicsFailed: '获取流行动态数据失败',
    getSubcladeMapFailed: '获取亚分支映射数据失败，将使用空映射',
    loadSubcladeMapFailed: '加载亚分支映射数据失败',
  },
  phylogeneticTree: {
    legend: '图例',
    clades: '分支',
    vaccineStrains: '疫苗株',
    console: {
      treeStringChanged: '进化树字符串已更改',
      cladeColorsChanged: '分支颜色映射已更改',
      originalTreeString: '原始进化树字符串',
      cannotParseTree: '无法解析进化树结构，使用原始字符串',
      nodeAnalysis: '节点分支分析',
      reorganizedTreeString: '重新组织的进化树字符串',
      reorganizeFailed: '重新组织进化树结构失败',
      parseTreeFailed: '解析进化树字符串失败',
      customLayoutComplete: '自定义布局完成，已排序的叶子节点',
      customLayoutFailed: '自定义布局算法失败，使用默认布局',
      analyzeTreeFailed: '分析进化树结构失败',
      nodeInfo: '节点分支信息'
    }
  },
  candidates: {
    tooltipContent: 'Epitope Mutations列：比较类别位点的氨基酸类型＋位点编号＋下一季推荐疫苗株位点的氨基酸类型',
    AntigenicTooltipContent: ' Antigenic Similarity列： 相对参考血清给出 HI 的方向性相似性结果，依据Francis Crick Institute的抗原性报告。',
    title: '下一流感季优势分支排序',
    desc: '基于 PHER 深度学习模型预测的病毒进化分支适应性排序',
    rank: '排名',
    branch: '分支',
    strain: '毒株',
    fitness: '适应性',
    confidence: '置信度',
    coverage: '覆盖地区',
    mutations: '关键突变',
    high: '高',
    medium: '中',
    low: '低',
    northAmerica: '北美',
    europe: '欧洲',
    asia: '亚洲',
    southAmerica: '南美',
    africa: '非洲',
    oceania: '大洋洲',
    predictionTarget: {
      title: '预测目标',
      season: '2025-2026 流感季',
      virusSubtype: '甲型流感 H3N2 亚型',
      modelConfidence: '模型置信度: 92.3%',
    },
    evolutionTree: {
      title: '病毒进化树',
      desc: '展示各分支的进化关系和适应性预测',
      placeholder: {
        virusEvolutionTree: '病毒进化树可视化',
        evolutionTreeDesc: '展示各分支的进化关系和适应性预测结果',
      },
      legend: {
        highAdaptability: '高适应性分支',
        mediumAdaptability: '中等适应性分支',
        lowAdaptability: '低适应性分支',
        currentPopularBranch: '当前流行分支',
      },
    },
    modelInfo: {
      title: 'PHER 模型信息',
      desc: '深度学习预测模型的详细参数',
      modelVersion: '模型版本',
      trainingData: '训练数据',
      predictionAccuracy: '预测准确率',
      featureDimension: '特征维度',
      updateFrequency: '更新频率',
    },
    predictionTrend: {
      title: '预测趋势',
      branch3C2A1b2a2: '3C.2A1b.2a.2 分支持续增长',
      k156eMutation: 'K156E 突变显著增加',
      f159yMutation: 'F159Y 突变需要关注',
    },
    table: {
      title: '候选分支详细排序',
      desc: '基于 PHER 模型预测的各分支适应性排序结果',
      rank: '排名',
      branch: '分支',
      strain: '代表毒株',
      fitness: '适应性',
      confidence: '置信度',
      coverage: '覆盖地区',
      mutations: '关键突变',
    },
    searchPlaceholder: '搜索分支或突变信息...',
    refreshData: '刷新数据',
    exportData: '导出数据',
    candidateBranches: '候选分支',
    riskMutations: '风险突变',
    topScore: '最高分数',
    loading: '加载中...',
    noData: '暂无数据',
    noDataDescription: '请检查数据源或刷新页面',
    loadDataFailed: '加载CSV数据失败',
    dataLoadFailed: '数据加载失败',
    nextSeasonDominantScore: '在下一个流感季优势传播的分数',
    cladeRiskMutations: 'Clade中的风险突变',
    candidateBranchAnalysisData: '候选分支分析数据',
  },
  recommendations: {
    title: '下一流感季推荐的疫苗株',
    desc: '基于预测结果的最终疫苗株推荐，为决策机构提供科学依据',
    pageTitle: '下一个流感季的推荐疫苗株与当前流行背景的比较',
    showSimpleTree: '展示简单进化树图',
    showDetailedTree: '展示详细进化树图',
    loading: '加载中...',
    noData: '暂无数据',
    tableColumns: {
      category: '类别',
      haDifference: 'HA氨基酸差异数',
      epitopeMutations: '抗原表位区位点突变集合',
      antigenicResult: '抗原显著性差异结果'
    },
    antigenicResults: {
      similar: '抗原相似',
      different: '抗原不相似'
    },
    keyInsights: {
      confidence: '推荐置信度',
      confidenceValue: '92.3%',
      confidenceDesc: '基于 PHER 模型的综合评估',
      protection: '预期保护效力',
      protectionValue: '78-85%',
      protectionDesc: '针对预测优势分支的保护率',
      coverage: '地理覆盖范围',
      coverageValue: '85%',
      coverageDesc: '全球流行地区的覆盖比例',
      risk: '风险评估',
      riskValue: '低',
      riskDesc: '疫苗株与预测分支的匹配风险',
    },
    table: {
      title: '疫苗株推荐表',
      desc: '基于预测结果的详细疫苗株推荐',
      level: {
        header: '优先级',
        首选: '首选',
        备选: '备选',
      },
      strain: {
        header: '毒株',
      },
      branch: {
        header: '分支',
      },
      antigenicDistance: {
        header: '抗原距离',
      },
      coverage: {
        header: '覆盖率',
      },
      confidence: {
        header: '置信度',
        高: '高',
        中: '中',
        低: '低',
      },
      mutations: {
        header: '关键突变',
      },
      rationale: {
        header: '推荐理由',
        '最高适应性预测，广泛地理覆盖': '最高适应性预测，广泛地理覆盖',
        '亚洲地区优势分支，适应性良好': '亚洲地区优势分支，适应性良好',
        '南美地区流行，中等适应性': '南美地区流行，中等适应性',
      },
    },
    disclaimerTitle: '重要说明',
    disclaimer: '本推荐基于 PHER 深度学习模型的预测结果，仅供科研参考。最终疫苗株选择需结合 WHO 专家委员会的综合评估和决策。预测结果的准确性受多种因素影响，包括病毒进化的不确定性、数据质量和模型局限性。',
    antigenMap: '抗原图谱分析',
    antigenMapDesc: '二维抗原图谱展示推荐疫苗株与流行株的抗原关系距离',
    antigenMapPlaceholder: '[占位符] 二维抗原图谱显示疫苗株与流行株的关系',
    antigenicMap: {
      title: '抗原图谱分析',
      desc: '二维抗原图谱展示推荐疫苗株与流行株的抗原关系距离',
      placeholderTitle: '二维抗原图谱可视化',
      placeholderDesc: '展示推荐疫苗株与流行株的抗原关系',
      legend: {
        recommended: '推荐疫苗株',
        current: '当前流行株',
        predicted: '预测优势株',
        historical: '历史疫苗株',
      },
    },
    timeline: {
      title: '决策时间线',
      desc: 'WHO 疫苗株选择的关键时间节点',
      '2024': '2024年12月',
      '2024Desc': '数据收集与分析完成',
      '2025Feb': '2025年2月',
      '2025FebDesc': 'WHO 专家委员会会议',
      '2025Mar': '2025年3月',
      '2025MarDesc': '疫苗株推荐发布',
      '2025Sep': '2025年9月',
      '2025SepDesc': '疫苗生产与分发',
    },
    quality: {
      title: '数据质量评估',
      desc: '推荐结果的可靠性指标',
      dataIntegrity: '数据完整性',
      dataIntegrityValue: '96%',
      modelAccuracy: '模型准确性',
      modelAccuracyValue: '92%',
      geographicCoverage: '地理覆盖度',
      geographicCoverageValue: '85%',
      timeliness: '时效性',
      timelinessValue: '100%',
    },
    phylogeneticTreeText: '进化树',
    loadSequenceCountsFailed: '获取序列数量数据失败',
    loadVaccineStrainsFailed: '加载疫苗株信息失败',
    getSimpleTreeVaccineInfoFailed: '获取简单进化树疫苗株信息失败',
    getDetailedTreeVaccineInfoFailed: '获取详细进化树疫苗株信息失败',
    cannotGetAnyTreeData: '无法获取任何进化树数据',
    simpleTreeLoadFailed: '简单进化树加载失败',
    detailedTreeLoadFailed: '详细进化树加载失败',
    loadTreeDataFailed: '加载进化树数据失败',
  },
  phylogeneticTree: {
    legend: '图例',
    clades: '分支',
    vaccineStrains: '疫苗株',
    vaccineStrainDisplay: "当前流感季推荐疫苗株",
    vaccineStrainDisplaynext: "下一流感季推荐疫苗株",
    futureflurecommended: 'FutureFlu推荐',
    whorecommended: 'WHO推荐',
    tooltip: {
      branch: '分支',
      normalBranch: '普通分支',
      sequenceId: '序列ID',
      branchName: '分支名称',
      nodeName: '节点名称',
      sequenceCount: '序列数量',
      branchColor: '分支颜色',
      status: '状态',
    },
    console: {
      treeStringChanged: '树结构字符串变化:',
      cladeColorsChanged: '分支颜色映射变化:',
      originalTreeString: '原始树字符串:',
      cannotParseTree: '无法解析树结构，使用原始字符串',
      nodeAnalysis: '节点分支分析:',
      reorganizedTreeString: '重新组织后的树字符串:',
      reorganizeFailed: '重新组织树结构失败:',
      parseTreeFailed: '解析树字符串失败:',
      nodeInfo: '节点分支信息:',
      customLayoutComplete: '自定义布局完成，叶子节点已排序',
      customLayoutFailed: '自定义布局算法失败，使用默认布局',
      analyzeTreeFailed: '分析树结构失败',
      renderTreeString: '渲染过程中重新组织的树字符串'
    }
  }
}
export default zh